module.exports = __webpack_public_path__ + "img/bg261@2x.9665f0c5.png";